import { SnackbarHider } from "tm-controls/snackbar-hider";

export const Page = (props: React.PropsWithChildren<{}>) => {
	return (
		<>
			<SnackbarHider />
			{props.children}
		</>
	);
}